export const nationwideGame = [
  //福彩
  {
    gameType: "10010",
    roomId: "25001",
    name: "福彩3D",
  },
  {
    gameType: "10010",
    roomId: "25101",
    name: "双色球",
  },
  {
    gameType: "10010",
    roomId: "25003",
    name: "快乐8",
  },
  {
    gameType: "10010",
    roomId: "25102",
    name: "七乐彩",
  },
  //体彩
  {
    gameType: "10011",
    roomId: "25005",
    name: "排列3",
  },
  {
    gameType: "10011",
    roomId: "25201",
    name: "大乐透",
  },
  {
    gameType: "10011",
    roomId: "25007",
    name: "排列5",
  },
  {
    gameType: "10011",
    roomId: "25103",
    name: "7星彩",
  },
  //10012
  {
    gameType: "10012",
    roomId: "25011",
    name: "福彩15选5",
  },
  {
    gameType: "10012",
    roomId: "25301",
    name: "东方6+1",
  },
  {
    gameType: "10012",
    roomId: "25013",
    name: "上海福彩天天彩选4",
  },
  {
    gameType: "10012",
    roomId: "25014",
    name: "河北福彩20选5",
  },
  {
    gameType: "10012",
    roomId: "25015",
    name: "河北福彩排列7",
  },
  {
    gameType: "10012",
    roomId: "25016",
    name: "河北福彩排列5",
  },
  {
    gameType: "10012",
    roomId: "25017",
    name: "河南福彩22选5",
  },
  {
    gameType: "10012",
    roomId: "25104",
    name: "黑龙江福彩36选7",
  },
  {
    gameType: "10012",
    roomId: "25019",
    name: "黑龙江福彩22选5",
  },
  {
    gameType: "10012",
    roomId: "25105",
    name: "黑龙江福彩P62",
  },
  {
    gameType: "10012",
    roomId: "25106",
    name: "黑龙江体彩6+1",
  },
  {
    gameType: "10012",
    roomId: "25022",
    name: "江苏体彩7位数",
  },
  {
    gameType: "10012",
    roomId: "25107",
    name: "浙江体彩6+1",
  },
  {
    gameType: "10012",
    roomId: "25024",
    name: "浙江体彩20选5",
  },
  {
    gameType: "10012",
    roomId: "25025",
    name: "福建体彩22选5",
  },
  {
    gameType: "10012",
    roomId: "25108",
    name: "福建体彩31选7",
  },
  {
    gameType: "10012",
    roomId: "25109",
    name: "福建体彩36选7",
  },
  // {
  //   gameType: "10012",
  //   roomId: "25110",
  //   name: "南粤福彩风采36选7",
  // },
  // {
  //   gameType: "10012",
  //   roomId: "25401",
  //   name: "南粤福彩风采好彩1",
  // },
  {
    gameType: "10012",
    roomId: "25030",
    name: "海南体彩4+1",
  },
  {
    gameType: "10012",
    roomId: "25111",
    name: "广西福彩快乐双彩",
  },
];

export const zodiac = [
  "鼠",
  "牛",
  "虎",
  "兔",
  "龙",
  "蛇",
  "马",
  "羊",
  "猴",
  "鸡",
  "狗",
  "猪",
];
